module.exports = "<igo-list [navigation]=\"true\">\r\n    <ng-template ngFor let-catalog [ngForOf]=\"catalogs\">\r\n      <igo-catalog-item\r\n        igoListItem\r\n        color=\"accent\"\r\n        [selected]=\"selectedCatalog\"\r\n        [catalog]=\"catalog\"\r\n        (select)=\"select.emit(catalog)\"\r\n        (unselect)=\"unselect.emit(catalog)\">\r\n      </igo-catalog-item>\r\n    </ng-template>\r\n</igo-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/catalog/catalog-list/catalog-list.component.html
// module id = 1052
// module chunks = 0